import React from "react";

import { ERROR_PAGE_LABELS } from "./constants/labels";
import ErrorHandler from "./error-handler";

const { NO_ACCESS } = ERROR_PAGE_LABELS;

const NoAccess = () => {
  return <ErrorHandler errorCase={NO_ACCESS} />;
};

export default React.memo(NoAccess);
